/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentSigningScope {
    PER_PARTICIPANT = 'PER_PARTICIPANT',
    ALL_PARTICIPANTS = 'ALL_PARTICIPANTS',
}
